// Optimised brand images, served from the Base44 media CDN (cached 30 days, immutable).
// The CDN resizes and converts to WebP on the fly from the original uploads.
const MEDIA = 'https://media.base44.com/images/public/6a54fc37929928fd03a2219b';

// Logos are shown at 40–56px tall; files are ~2x that so they stay sharp on phones. Both under 10 KB.
export const LOGO_DARK = {
  src: `${MEDIA}/952ba0aef_daley_logo_web_600.png/v1/fit/w_160,h_98,al_c,q_80,enc_webp/daley-logo.webp`,
  width: 160,
  height: 98,
};
export const LOGO_DARK_LARGE = {
  src: `${MEDIA}/952ba0aef_daley_logo_web_600.png/v1/fit/w_240,h_147,al_c,q_80,enc_webp/daley-logo-240.webp`,
  width: 240,
  height: 147,
};
export const LOGO_WHITE = {
  src: `${MEDIA}/07b32ad3b_daley_logo_whitewriting.png/v1/fit/w_160,h_98,al_c,q_80,enc_webp/daley-logo-white.webp`,
  width: 160,
  height: 98,
};

// Hero photo in several sizes so phones download a small file (keep in sync with the preload in index.html).
const HERO_WIDTHS = [480, 768, 1024, 1600];
const heroUrl = (w) =>
  `${MEDIA}/65aced434_generated_image.png/v1/fill/w_${w},h_${Math.round((w * 3) / 4)},al_c,q_80,usm_0.66_1.00_0.01,enc_webp,quality_auto/hero-${w}.webp`;

export const HERO = {
  src: heroUrl(1024),
  srcSet: HERO_WIDTHS.map((w) => `${heroUrl(w)} ${w}w`).join(', '),
  width: 1024,
  height: 768,
};

// `sizes` tells the browser how wide the image shows. On phones we deliberately say "75% of the screen"
// so very dense phone screens (2.5–3x) pick the 768px file (~48 KB) instead of the 1600px one (~100 KB),
// while Google's test phone (1.75x) gets the 480px file (~25 KB). Still ~2x sharp. Keep in sync with index.html.
export const HOME_HERO_SIZES = '(min-width: 1024px) 50vw, (min-width: 768px) 100vw, 75vw';
export const OFFER_HERO_SIZES = '(min-width: 768px) 100vw, 75vw';

// Any other photo on the Base44 media CDN, served as resized WebP in several widths (4:3 crop).
export function responsivePhoto(file, widths = [480, 768, 1024, 1600]) {
  const url = (w) =>
    `${MEDIA}/${file}/v1/fill/w_${w},h_${Math.round((w * 3) / 4)},al_c,q_80,usm_0.66_1.00_0.01,enc_webp,quality_auto/${file.replace(/\.[a-z0-9]+$/i, '')}-${w}.webp`;
  return { src: url(1024), srcSet: widths.map((w) => `${url(w)} ${w}w`).join(', '), width: 1024, height: 768 };
}

// Same, from a full image address stored in the database (e.g. a blog post's image_url).
// Falls back to the plain address for images that aren't on the Base44 media CDN.
export function responsivePhotoFromUrl(url) {
  if (!url || !url.startsWith(`${MEDIA}/`)) return { src: url, srcSet: undefined, width: 1024, height: 768 };
  const file = url.slice(MEDIA.length + 1).split('/v1/')[0];
  return responsivePhoto(file);
}
